var React = require('react');
var ReactDOM = require('react-dom'); 
var Utils = require('./utils');
var ReactRouter = require('react-router');
var Reflux = require('reflux');
var ScreenWid = require('./stores/screen-wid-store');
var Link = ReactRouter.Link;

var PostBlock = React.createClass({

  postLink: "",

  setBorderDivHei: function(hei) {
    jQuery('.link-to-post').height(hei);
  },

  componentDidMount: function() {
    jQuery(window).scroll();
    var self = this;

    jQuery('<img/>').attr('src', this.props.post.imgThumb).load(function() {
      setTimeout(function() { 
        self.props.imageLoaded(jQuery('.link-to-post').height());
      }, 10);
      jQuery(this).remove();
    });

  },

  rawMarkup: function() {
    return { __html: this.props.post.excerpt };
  },

  render: function() {
    var post = Utils.reconstructPost(this.props.post.content);

    this.postLink = "/blogs" + this.props.post.url.substring("/blogs".length);
    return <div className={"col-sm-6 post-thumb" + (this.props.noFade ? "" : " fade-in")}
                key={this.props.post.date}>
        <div className="for-border">
            <Link to={this.postLink} className="link-to-post">
                <div ref="headerImg" className="header-img"
                     style={{background: 'url(' + this.props.post.imgThumb + ') center bottom no-repeat'}}>
                </div>
                <div className="text-wrap">
                    <p className="lead">- {this.props.post.postType} -</p>
                    <h2>{this.props.post.title}</h2>
                    <div dangerouslySetInnerHTML={this.rawMarkup()}></div>
                </div>
            </Link>
        </div>
      </div>
  }
});

module.exports = React.createClass({

  mixins: [ Reflux.ListenerMixin ],

  imgHei: 0,
  posts: [],
  curWid: "",

  getInitialState: function() {
    this.listenTo(ScreenWid, this.onScreenWid);
    this.onScreenWid(null, ScreenWid.width);

    if (this.props.posts) {
      return { posts: _.map(this.props.posts,
                            function(post) {
                              return <PostBlock post={post} key={post.id}
                                                imageLoaded={this.postImageLoaded}
                                                ref={ function(p) { this.posts.push(p); }.bind(this) }/>
                            }.bind(this))};
    } else {
      return { posts: [] };
    }
  },

  postImageLoaded: function(hei) {
    if ("SM" == this.curWid) return;

    if (this.imgHei) {
      var maxHei = Math.max(this.imgHei, hei);

      this.posts[0].setBorderDivHei(maxHei);
      this.posts[1].setBorderDivHei(maxHei);
    } else {
      this.imgHei = hei;
    }
  },

  onScreenWid: function(event, wid) {
    this.curWid = wid;
  },

  setPosts: function(posts) {
    if (0 == posts.length) {
      this.setState({ posts: null });
      return;
    }
    this.setState({ posts: _.map(posts,
                                 function(post) {
                                   return <PostBlock post={post} key={post.id}
                                                     noFade={this.props.noFade ? this.props.noFade : false}
                                                     imageLoaded={this.postImageLoaded}
                                                     ref={ function(p) { this.posts.push(p); }.bind(this) }/>
                                 }.bind(this))});
  },

  render: function() {
    return <div className="row post-row">
            {this.state.posts}
      </div>
  }
});